import { defineComponent as _defineComponent } from 'vue'
import { computed as _computed } from 'vue';

import __MACROS_useVModel from "/vue-macros/define-models/use-vmodel";
import { useSlots } from 'vue';

interface SCardProps {
  /**
   * Card title
   */
   title: string,
  /**
   * Card subtitle
   */
  subtitle?: string,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SSwitchAccordion',
  props: {
  title: { default: '' },
  subtitle: { default: '' },
  value: { type: Boolean }
},
  emits: ["input"],
  setup(__props) {

const props = __props;

const slots = useSlots();

const { value } = __MACROS_useVModel(["value", undefined, "input"]);



const hasTitleContent = _computed(() => !!props.title || !!props.subtitle);


return { __sfc: true,slots, value, props, hasTitleContent, _computed, __MACROS_useVModel, useSlots }
}

})